var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined",
    attrs: {
      "items-per-page": -1,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.product`,
      fn: function (_ref2) {
        var _item$product, _item$product2, _item$product3;
        var item = _ref2.item;
        return [_c('v-row', {
          staticClass: "pa-3 pa-sm-0",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "pa-0 pa-sm-3 purchase-item-image",
          attrs: {
            "cols": "12",
            "sm": "auto"
          }
        }, [_c('image-popup', {
          attrs: {
            "src": `/res/shop/products/${item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product._id}/${item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.thumb}`,
            "size": "40",
            "rounded": "lg"
          }
        })], 1), _c('v-col', {
          staticClass: "pa-0 pa-sm-3"
        }, [_c('div', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(item.purchaseNo))]), _c('div', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.name) + " "), _c('br', {
          staticClass: "d-sm-none"
        }), _c('span', {
          staticClass: "d-none d-sm-inline"
        }, [_vm._v("/")]), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.name) + " ")])])], 1)];
      }
    }, {
      key: `item.orderStatusMessage`,
      fn: function (_ref3) {
        var item = _ref3.item,
          value = _ref3.value;
        return [_c('v-layout', {
          attrs: {
            "align-center": ""
          }
        }, [_c('span', [_vm._v(_vm._s(value))]), _c('order-view-delivery', {
          attrs: {
            "purchase": item
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref4) {
              var attrs = _ref4.attrs,
                on = _ref4.on,
                shows = _ref4.shows;
              return [shows ? _c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "icon": "",
                  "text": "",
                  "small": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-truck-outline")])], 1) : _vm._e()];
            }
          }], null, true)
        })], 1)];
      }
    }, {
      key: `item.claimStatusMessage`,
      fn: function (_ref5) {
        var item = _ref5.item,
          value = _ref5.value;
        return [_c('v-layout', {
          attrs: {
            "align-center": ""
          }
        }, [_c('span', [_vm._v(_vm._s(value))]), _c('order-view-claim', {
          attrs: {
            "purchase": item
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref6) {
              var attrs = _ref6.attrs,
                on = _ref6.on,
                shows = _ref6.shows;
              return [shows ? _c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "icon": "",
                  "text": "",
                  "small": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-clipboard-alert-outline")])], 1) : _vm._e()];
            }
          }], null, true)
        })], 1)];
      }
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers,
    itemClass: _vm.itemClass
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }